import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatetimeModalComponent } from './datetime-modal.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [DatetimeModalComponent],
  exports: [DatetimeModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ]
})
export class DatetimeModalModule { }
